import { defineComponent as o, openBlock as n, createBlock as r, unref as a, withCtx as i, createElementVNode as f } from "vue";
import l from "../SfIconBase/SfIconBase.vue.mjs";
import { SfIconSize as s } from "@storefront-ui/shared";
const u = /* @__PURE__ */ o({
  __name: "SfIconChevronLeft",
  props: {
    size: {
      type: String,
      default: s.base
    }
  },
  setup(t) {
    return (m, e) => (n(), r(a(l), {
      size: t.size,
      viewBox: "0 0 24 24",
      "data-testid": "chevron-left"
    }, {
      default: i(() => e[0] || (e[0] = [
        f("path", { d: "M14.706 17.297a1 1 0 0 0 0-1.41l-3.876-3.885 3.877-3.885a.998.998 0 0 0-1.412-1.41l-4.588 4.588a1 1 0 0 0 0 1.414l4.588 4.588a.997.997 0 0 0 1.41 0" }, null, -1)
      ])),
      _: 1
    }, 8, ["size"]));
  }
});
export {
  u as default
};
